module.exports = __webpack_public_path__ + "volum_circle3.png?f48aaa1179e35737294f475bfe40d940";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volum_circle3.png
// module id = 700
// module chunks = 0